import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useContext, useEffect, useState } from "react"
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import _ from "underscore";
import { callautopopulate } from "../../../../services/callautopop";
import { ToastContext } from "../../../../context/ToastContext";

export const useFieldSchemeIssueType = ({ filterValues, setFilterValues }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [create, setCreate] = useState({ visible: false, issueType: {}, fieldConfig: {}, editData: {}, isDelete: false });
    const [options, setOptions] = useState({ issueType: [], fieldConfig: [], filteredIssueType: [] })
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const [rowData, setRowData] = useState([])
    const columns = [
        {
            key: "issue_type_name",
            label: "Issue Type",
            style: { width: "45%" },
            render: (row) => <div>
                <div className="fw-bold text-truncate" style={{ fontSize: "12px" }} title={row?.issue_type_name}>{row?.issue_type_name || "Default"}</div>
                {row?.issue_type_name === null && <div className="fw-bold" style={{ fontSize: "10px", color: "#a1a1a1" }}>FALLBACK</div>}
            </div>
        },
        {
            key: "field_configuration_name",
            label: "Field Configuration",
            style: { width: "45%" },
            render: (row) => row?.field_configuration_name && <div className="text-primary bg-light text-truncate round-small-section" title={row?.field_configuration_name} onClick={() => setFilterValues((prev) => ({ ...prev, tab: "field_config", config: { field_configuration_id: row?.field_configuration_id, field_configuration_name: row?.field_configuration_name, field_configuration_description: row?.field_configuration_description }, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-link" /> {row?.field_configuration_name}</div>
        },
        {
            key: "",
            label: "Actions",
            sort: false,
            style: { width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="d-flex gap-3 align-items-center justify-content-center">
                <div className="c-pointer text-primary" title="Edit" onClick={() => { handleEdit(row) }}><FontAwesomeIcon icon={faPenToSquare} /></div>
                {row?.issue_type_name !== null && <div className="c-pointer text-danger" title="Delete" onClick={() => setCreate((prev) => ({ ...prev, isDelete: true, editData: row }))}><FontAwesomeIcon icon={faTrashCan} /></div>}
            </div>
        },
    ]
    const formFields = [
        {
            label: "Issue Type",
            name: "issueType",
            col: "12",
            type: "select",
            option: options?.filteredIssueType,
            required: _.isEmpty(_.filter(rowData?.[0]?.children, item => !item?.issue_type_id)) ? false : true,
            disabled: !_.isEmpty(create?.editData) && !create?.issueType?.issue_type_id
        },
        {
            label: "Field Configuration",
            name: "fieldConfig",
            col: "12",
            type: "select",
            option: options?.fieldConfig,
            required: true,
        },
    ]

    useEffect(() => {
        callautopopulate("field_configuration_issue_type", "field_configuration")?.then(res => {
            setOptions((prev) => ({
                ...prev,
                issueType: res?.field_configuration_issue_type?.sort((a, b) => a?.issue_type_name?.localeCompare(b?.issue_type_name))?.map(item => { return { ...item, label: item?.issue_type_name } }),
                fieldConfig: res?.field_configuration?.sort((a, b) => a?.field_configuration_name?.localeCompare(b?.field_configuration_name))?.map(item => { return { ...item, label: item?.field_configuration_name } })
            }));
        })
    }, [])

    useEffect(() => {
        (filterValues?.apiCall && !_.isEmpty(options?.issueType)) && getSchemeIssueTypes()
    }, [filterValues?.apiCall, options?.issueType])

    const getSchemeIssueTypes = async () => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            const payload = {
                field_configuration_scheme_id: filterValues?.scheme?.field_configuration_scheme_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETFIELDCONFIGURATIONSCHEMEDETAILS"), payload);
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.field_configuration_schemes_details?.sort((a, b) => a?.issue_type_name?.localeCompare(b?.issue_type_name));
                const filteredData = _.filter(data, item => item?.issue_type_name)?.concat(_.filter(data, item => !item?.issue_type_name));
                setRowData([{ id: "all", title: "", children: filteredData }]);
                handleIssueTypeFilter(data);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, grid: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
        }
    }

    const upsertIssueTypeMapping = async () => {
        try {
            if (_.isEmpty(create?.issueType) && !create?.isDelete && !_.isEmpty(_.filter(rowData?.[0]?.children, item => !item?.issue_type_id))) {
                showInfo("Info", "Please select issue type");
                return;
            } else if (_.isEmpty(create?.fieldConfig) && !create?.isDelete) {
                showInfo("Info", "Please select field configuration");
                return;
            } else if (!_.isEmpty(create?.editData) && create?.editData?.field_configuration_id === create?.fieldConfig?.field_configuration_id && create?.editData?.issue_type_id === create?.issueType?.issue_type_id) {
                showInfo("Info", "No changes made!");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                field_configuration_mapping_id: (!_.isEmpty(create?.editData) ? create?.editData?.field_configuration_mapping_id : 0) || 0,
                field_configuration_scheme_id: filterValues?.scheme?.field_configuration_scheme_id || 0,
                field_configuration_id: create?.fieldConfig?.field_configuration_id || 0,
                issue_type_id: create?.issueType?.issue_type_id || 0,
                is_deleted: create?.isDelete || false
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTFIELDCONFIGURATIONDETAILSSCHEME"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                if (create?.isDelete) {
                    setRowData((prev) => [{ id: "all", title: "", children: _.filter(prev?.[0]?.children, item => item?.field_configuration_mapping_id !== payload?.field_configuration_mapping_id) }]);
                } else {
                    getSchemeIssueTypes();
                }
                setCreate((prev) => ({ ...prev, visible: false, issueType: {}, fieldConfig: {}, editData: {}, isDelete: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const handleIssueTypeFilter = (data) => {
        const filteredIssueType = _.filter(options?.issueType, item => !_.pluck(data, "issue_type_id")?.includes(item?.issue_type_id)) || [];
        setOptions((prev) => ({ ...prev, filteredIssueType }));
        return filteredIssueType;
    }

    const handleEdit = (row) => {
        let issueType = {};
        const filteredIssueType = handleIssueTypeFilter(rowData?.[0]?.children);
        if (row?.issue_type_id) {
            issueType = _.findWhere(options?.issueType, { issue_type_id: row?.issue_type_id }) || {};
        } else {
            issueType = { issue_type_name: "Default", issue_type_id: 0, label: "Default" }
        }
        const fieldConfig = _.findWhere(options?.fieldConfig, { field_configuration_id: parseInt(row?.field_configuration_id) }) || {};
        setCreate((prev) => ({ ...prev, visible: true, issueType, fieldConfig, editData: row }));
        !_.isEmpty(issueType) && setOptions((prev) => ({ ...prev, filteredIssueType: [issueType, ...filteredIssueType] }));
    }

    const handleChange = (item, e) => {
        setCreate((prev) => ({ ...prev, [item?.name]: e?.target?.value, isChange: true }));
    }

    return { columns, rowData, loader, options, create, setCreate, upsertIssueTypeMapping, handleIssueTypeFilter, formFields, handleChange }
}